import Vue from 'vue'
import CONST from '@/utils/const'
import router from '@/router/index'
import Nzh from 'nzh'

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

export function sortChange(data, queryCondition) {
  const { prop, order } = data
  if (prop) {
    queryCondition.sort = prop
    queryCondition.order = order === 'ascending' ? 'asc' : 'desc'
  } else {
    queryCondition.sort = 'id'
    queryCondition.order = 'desc'
  }
}

export function df(value, cFormat) {
  let date = Date.now()
  if (value) {
    date = value
  }
  return parseTime(date, cFormat || '{y}-{m}-{d}')
}

export function fillDictList(dictList, idsArray, listArray) {
  if (idsArray && listArray && idsArray.length === listArray.length) {
    if (dictList && dictList.length > 0) {
      dictList.forEach(row => {
        const index = idsArray.findIndex(id => id === row.type)
        if (index !== -1) {
          listArray[index].push(row)
        }
      })
    }
  }
}

/**
 * 用于提供cascader组件的value转换map
 * e.g: dept_id = 5时 需要将值 5 转换 为按级次的 [1, 2, 5]
 * */
export function generateMapOfIdsArray(rows, mapOfIdsArray, mapOfNamesArray) {
  const handlerRows = (row, idsArray, namesArray) => {
    idsArray.push(row.id)
    namesArray.push(row.label)
    mapOfIdsArray[row.id] = idsArray
    if (mapOfNamesArray) {
      mapOfNamesArray[row.id] = namesArray
    }
    if (row.children && row.children.length > 0) {
      row.children.forEach(row => {
        handlerRows(row, Vue.prototype._.cloneDeep(idsArray), Vue.prototype._.cloneDeep(namesArray))
      })
    }
  }
  if (rows && rows.length > 0) {
    rows.forEach(row => {
      handlerRows(row, [], [])
    })
  }
}

export function generateMapOfIdAndIdsArray(rows, mapOfIdsArray, mapOfNamesArray, mapOfId) {
  const handlerRows = (row, idsArray, namesArray) => {
    idsArray.push(row.id)
    namesArray.push(row.label)
    mapOfId[row.id] = row
    mapOfIdsArray[row.id] = idsArray
    if (mapOfNamesArray) {
      mapOfNamesArray[row.id] = namesArray
    }
    if (row.children && row.children.length > 0) {
      row.children.forEach(row => {
        handlerRows(row, Vue.prototype._.cloneDeep(idsArray), Vue.prototype._.cloneDeep(namesArray))
      })
    }
  }
  if (rows && rows.length > 0) {
    rows.forEach(row => {
      handlerRows(row, [], [])
    })
  }
}

export function setTreeData(rows, callbackFun) {
  const handlerRows = (row) => {
    callbackFun(row)
    if (row.children && row.children.length > 0) {
      row.children.forEach(row => {
        handlerRows(row)
      })
    }
  }
  if (rows && rows.length > 0) {
    rows.forEach(row => {
      handlerRows(row)
    })
  }
}
/**
 * 清空对象的属性
 * */
export function resetValue(obj) {
  delete obj.id
  for (const attr in obj) {
    if (
      attr === 'token' ||
      attr === 'page' ||
      attr === 'rows' ||
      attr === 'total' ||
      attr === 'sort' ||
      attr === 'order' ||
      attr === 'type' ||
      attr === 'prev_type'
    ) {
      continue
    } else if (
      attr.endsWith('_amount') ||
      attr.endsWith('_count') ||
      attr === 'score'
    ) {
      obj[attr] = 0
    } else if (
      attr.endsWith('Map') ||
      attr.endsWith('Data') ||
      attr.endsWith('Array') ||
      attr.endsWith('List') ||
      attr.endsWith('Range') ||
      attr.endsWith('_details') ||
      attr === 'details'
    ) {
      obj[attr] = []
    } else if (
      attr.startsWith('is_') ||
      attr.endsWith('_id') ||
      attr.endsWith('_id2') ||
      attr === 'status' ||
      attr.endsWith('_status')
    ) {
      obj[attr] = null
    } else {
      obj[attr] = ''
    }
  }
}

/**
 * 交换数组元素
 * */
export function swapElements(array, index1, index2) {
  array[index1] = array.splice(index2, 1, array[index1])[0]
  return array
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num, digits) {
  return (+num || 0).toFixed(digits || CONST['DECIMAL'].DEFAULT_PRECISION)
    .toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function toThousandFilterNoZero(num, digits, suffix) {
  if (+num === 0) {
    return ''
  } else {
    if (suffix) {
      return toThousandFilter(num, digits) + ' ' + suffix
    } else {
      return toThousandFilter(num, digits)
    }
  }
}

/**
 * 将 阿拉伯数字 转换成 中文大写数字
 * @param num
 * @returns string
 */
export function convertNumToChinese(num) {
  const nzhcn = Nzh.cn
  return nzhcn.toMoney(num, { outSymbol: false })
}

export function localeCompare(array, compareField) {
  if (compareField) {
    return array.sort((obj1, obj2) => {
      return obj1[compareField].localeCompare(obj2[compareField], 'zh')
    })
  } else {
    return array.sort((obj1, obj2) => {
      return obj1.localeCompare(obj2, 'zh')
    })
  }
}

export function getConstColor(value, key) {
  const findItem = CONST[key].find(item => item.id === value)
  return findItem ? findItem.color : ''
}

export function goBack() {
  Vue.prototype.confirm('您录入的表单可能尚未保存，确定离开吗？').then(() => {
    router.push('/')
  }).catch(() => {})
}

export function prefixInteger(num, length) {
  return (Array(length).join('0') + num).slice(-length)
}



// WEBPACK FOOTER //
// ./src/utils/index.js